import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import { Grid, Row, Col } from 'react-flexbox-grid';
import { Statistic, Result, Button, Modal, Calendar, message, Form, Input, InputNumber, Select  } from 'antd';
import { FileAddOutlined, UserOutlined, CalendarOutlined, FieldTimeOutlined } from '@ant-design/icons';
import { setNextReservationsByRestaurantId } from './../../../actions/setNextReservationsByRestaurantId';
import { setNewStateToReserve } from './../../../actions/setNewStateToReserve';
import { getRestaurant, getNextReservations } from './../../../reducers';
import SelectDate from './../../../components/calendar/SelectDate';
import LoadingPage from './../../../components/LoadingPage';
import ReservationsTable from './../../../components/tables/ReservationsTable';
import { MenuResto, LOGIN } from '../../../constants/menu_items';
import SelectDateWithCalendar from '../../../components/calendar/SelectDateWithCalendar';
import Picker from 'react-scrollable-picker';
import { SET_ACTIVE_RESTAURANT_ADMIN } from '../../../actions/SetActivePropToRestaurant';
import { cloudFunctions } from '../../../config/Fire';
import './styles.css';

const { Option } = Select;

function compareHour( a, b ) {
    const hourA = moment(a.hour, 'hh:mm');
    const hourB = moment(b.hour, 'hh:mm');
    if ( hourA.isAfter(hourB) ) {
      return 1;
    }
    if ( hourA.isBefore(hourB) ) {
      return -1;
    }
    return 0;
};

const TodayReservations = props => {
    const { nextReservations, restaurant } = props;

    const[dateSelected, setDateSelected] = useState(moment(new Date()).format('DD/MM/YYYY'))
    const[modalNewReserveVisibility, setModalNewReserveVisibility] = useState(false)
    const[peopleCountNewReserve, setPeopleCountNewReserve] = useState("1")
    const[dateNewReserve, setDateNewReserve] = useState(moment(new Date()).utcOffset('-0300').format("DD/MM/YYYY"))
    const[hoursAvailableOnDateNewReserve, setHoursAvailableOnDateNewReserve] = useState(null)
    const[hourSelectedOnDateNewReserve, setHourSelectedOnDateNewReserve] = useState(null)
    const[gettingAvailableHoursPerDate, setGettingAvailableHoursPerDate] = useState(false)
    const[reserving, setReserving] = useState(false)

    const [form] = Form.useForm();

    const onDateSelected = (date, dateString) => {
        setDateSelected(dateString)
    };

    const onActionSelected = (state, newState, id) => {
        const { nextReservations, restaurant } = props;
        var reserve = nextReservations[id];
        if(reserve) {
            //console.log(state + " " + newState + " " + id);
            const dateReserveDash = moment(reserve.date, 'DD/MM/YYYY').format('DD-MM-YYYY');
            const placesOccupied = (restaurant.actualReservations && restaurant.actualReservations[dateReserveDash] && restaurant.actualReservations[dateReserveDash][reserve.hour]) ? restaurant.actualReservations[dateReserveDash][reserve.hour] : 0;
            props.setNewStateToReserve(state, newState, reserve, placesOccupied);
        }
    }

    const getData = () => {
        const { setNextReservationsByRestaurantId, restaurant } = props;
        if(restaurant) {
            setNextReservationsByRestaurantId(restaurant.id);
        }
    }

    const getNextReservations =() => {
        const { nextReservations } = props;
        if(!nextReservations) {
            getData();
            return <LoadingPage className="LoadingPageCont"/>;
        }
    }

    const renderData = (dateSelected) => {
        const { nextReservations, restaurant } = props;
        if(restaurant && nextReservations) {
            const data = [];
            var reservations = [];
            for (var key in nextReservations) {
                reservations.push(nextReservations[key]);
            }
            reservations.sort(compareHour);
            reservations.forEach(reserve => {
                const dateReserve = moment(reserve.date, 'DD/MM/YYYY').format('DD/MM/YYYY');
                const dateReserveDash = moment(reserve.date, 'DD/MM/YYYY').format('DD-MM-YYYY');
                if(dateReserve === dateSelected) {
                    data.push({
                        id: reserve.reservationId,
                        hour: reserve.hour, 
                        name: reserve.user.userName,
                        phone: reserve.user.userPhone,
                        email: reserve.user.userEmail,
                        averageReservationTime: reserve.averageReservationTime,
                        state: reserve.state,
                        discount: reserve.discount ? reserve.discount : "0",
                        platform: reserve.platform ? reserve.platform : "Android",
                        //rating: reserve.user.userRating ? reserve.user.userRating : 0,
                        peopleCount: reserve.peopleCount,
                        reservations: {
                            totalReservationsCount: reserve.user.userTotalReservationsCount ? reserve.user.userTotalReservationsCount : 0,
                            assistedReservationsCount: reserve.user.userAssistedReservationsCount ? reserve.user.userAssistedReservationsCount : 0,
                            cancelledReservationsCount: reserve.user.userCancelledReservationsCount ? reserve.user.userCancelledReservationsCount : 0,
                        },
                        placesOccupied: {
                            occupied: (restaurant.actualReservations && restaurant.actualReservations[dateReserveDash] && restaurant.actualReservations[dateReserveDash][reserve.hour]) ? restaurant.actualReservations[dateReserveDash][reserve.hour] : 0,
                            total: restaurant.reservationCapacity
                        }
                    });
                }
            });
            if(data.length !== 0) {
                return <ReservationsTable data={data} onShowReservation={(id) => showReservation(id)} onActionSelected={(state, newState, id) => onActionSelected(state, newState, id)} />;
            } else {
                return <Result status="warning" title="No hay reservas para la fecha indicada." />;
            }
        }
    }

    const renderSelectDateWithReservations = nextReservations => {
        if(nextReservations) {
            const datesWithReservations = [];
            var reservations = [];
            for (var key in nextReservations) {
                reservations.push(nextReservations[key]);
            }
            reservations.forEach(reserve => {
                const dateReserve = moment(reserve.date, 'DD/MM/YYYY').format('DD/MM/YYYY');
                if(datesWithReservations.indexOf(dateReserve) === -1) {
                    datesWithReservations.push(dateReserve);
                }
            });
            return <SelectDate className="SelectDateCont" datesWithReservations={datesWithReservations} dateSelected={dateSelected} onDateSelected={onDateSelected} disabledBeforeTodayDate={true} />
        }
    }

    const onSelected = date => {
        var dateString = moment(date).format('DD/MM/YYYY');
        setDateSelected(dateString)
    };

    const renderSelectDateWithReservationsCalendar = nextReservations => {
        if(nextReservations) {
            const datesWithReservations = [];
            var reservations = [];
            for (var key in nextReservations) {
                reservations.push(nextReservations[key]);
            }
            reservations.forEach(reserve => {
                const dateReserve = moment(reserve.date, 'DD/MM/YYYY').format('DD/MM/YYYY');
                if(datesWithReservations.indexOf(dateReserve) === -1) {
                    datesWithReservations.push(dateReserve);
                }
            });
            return <SelectDateWithCalendar datesWithReservations={datesWithReservations} dateSelected={dateSelected} onSelected={(date) => onSelected(date)} disabledBeforeTodayDate={true} />
        }
    }

    const showReservation = id => {
        const { nextReservations } = props;
        if(nextReservations && nextReservations[id]) {
            props.history.push(`/${LOGIN}/${MenuResto.RESERVATION_BY_ID}/${id}`);
        }
    }

    const onNewReserve = () => {
        setModalNewReserveVisibility(true)
    }

    const handleCancelNewReserveModal = () => {
        setModalNewReserveVisibility(false)
        setPeopleCountNewReserve("1")
        setDateNewReserve(moment(new Date()).utcOffset('-0300').format("DD/MM/YYYY"))
        setHoursAvailableOnDateNewReserve(null)
        setHourSelectedOnDateNewReserve(null)
        setGettingAvailableHoursPerDate(false)
        setReserving(false)
    }

    const handlePeopleCountNewReserve = value => {
        setPeopleCountNewReserve(value)
        setHoursAvailableOnDateNewReserve(null)
        setHourSelectedOnDateNewReserve(null)
    }

    const handleDateNewReserve = value => {
        setDateNewReserve(moment(value).format('DD/MM/YYYY'))
        setHoursAvailableOnDateNewReserve(null)
        setHourSelectedOnDateNewReserve(null)
    }

    const handleGetAvailableHoursPerDate = () => {
        setGettingAvailableHoursPerDate(true)
        cloudFunctions.getAvailableHoursPerDate({
            peopleCount: peopleCountNewReserve,
            date: dateNewReserve,
            restoId: restaurant.id
        })
        .then(result => {
            setGettingAvailableHoursPerDate(false)
            if(result && result.data && result.data.code === 0 && result.data.availableHours) {
                if(result.data.availableHours.length === 0) {
                    message.error("No hay horas disponibles para la fecha seleccionada.")
                    setHoursAvailableOnDateNewReserve(null)
                    setHourSelectedOnDateNewReserve(null)
                } else {
                    setHoursAvailableOnDateNewReserve(result.data.availableHours)
                    setHourSelectedOnDateNewReserve(result.data.availableHours[0])
                }
            } else {
                message.error("No hay horas disponibles para la fecha seleccionada.")
                setHoursAvailableOnDateNewReserve(null)
                setHourSelectedOnDateNewReserve(null)
            }
        })
        .catch(err => {
            setGettingAvailableHoursPerDate(false)
            message.error("Se produjo un error al traer las horas. Por favor, refresque la pagina y vuelva a intentar.")
            setHoursAvailableOnDateNewReserve(null)
            setHourSelectedOnDateNewReserve(null)
        })
    }

    const getNumberArrayOfHoursAvailable = hours => {
        const number = [];
        hours.forEach(hour => {
            number.push({ value: `${hour}`, label: `${hour}` })
        });
        return { number: number }
    }

    const handleHourSelectedOnDateNewReserve = value => {
        setHourSelectedOnDateNewReserve(value)
    }

    const handleTryReserve = () => {
        form.validateFields()
        .then(values => {
            setReserving(true)
            cloudFunctions.tryReserveFromRestaurant({
                restoId: restaurant.id,
                date: dateNewReserve,
                hour: hourSelectedOnDateNewReserve,
                peopleCount: peopleCountNewReserve,
                observations: "",
                platform: "web",
                userEmail: values.field_email,
                userPhone: values.field_phone,
                userDNI: values.field_dni,
                userFirstName: values.field_first_name,
                userLastName: values.field_last_name,
                userStreet: values.field_street,
                userCity: values.field_city,
                userProvince: values.field_province,
                userCountry: values.field_country
            })
            .then(result => {
                setReserving(false)
                console.log("result: " + JSON.stringify(result))
                if(result && result.data && result.data.code === 0 && result.data.reserveState) {
                    switch (result.data.reserveState) {
                        case "Available":
                            message.success("La reserva se realizó exitósamente.");
                            handleCancelNewReserveModal();
                            break;
                        case "closed":
                            message.error("El restaurante se encuentra cerrado.");
                            break;
                        case "restoIncorrectFields":
                            message.error("Se produjo un error al reservar.");
                            break;
                        case "notAvailable":
                            if(result.data.reason) {
                                switch (result.data.reason) {
                                    case "placesNotAvailable":
                                        message.error("No hay lugares disponibles.");
                                        break;
                                    case "minimumPreviousReservationHours":
                                        const errorMinimum = `La reserva debe realizarse con un mínimo de ${result.data.minimumPreviousReservationHours ? result.data.minimumPreviousReservationHours : "NUMBER"} horas de anticipación.`
                                        message.error(errorMinimum);
                                        break;
                                    case "maximumPreviousReservationDays":
                                        const errorMaximum = `No es posible realizar una reserva con anticipación máxima a ${result.data.maximumPreviousReservationDays ? result.data.maximumPreviousReservationDays : "NUMBER"} días.`
                                        message.error(errorMaximum);
                                        break;
                                    default:
                                        break;
                                }
                            } else {
                                message.error("No es posible realizar una reserva con las configuraciones seleccionadas.");
                            }
                            break;
                        default:
                            message.error("Se produjo un error al reservar.");
                            break;
                    }
                } else {
                    message.error("Se produjo un error al reservar. Por favor, refresque la página y vuelva a intentar.")
                }
            })
            .catch(err => {
                setReserving(false)
                message.error("Se produjo un error al reservar. Por favor, refresque la página y vuelva a intentar.")
            })
        })
        .catch(() =>{})
    }

    return (
        <Grid className="todayReservationsCont">
            <Row middle="md" className="dataRestoCont">
                {/*<Col xs={12} sm={12} md={3}>
                    {
                        nextReservations ?
                            renderSelectDateWithReservations(nextReservations)
                            :
                            <SelectDate className="SelectDateCont" dateSelected={dateSelected} onDateSelected={(date) => onDateSelected(date)} disabledBeforeTodayDate={true} />
                    }
                </Col>*/}
                <Col xs={12} sm={12} md={4}>
                    { restaurant && <Statistic title={"Tiempo medio de reservas"} value={`${restaurant.averageReservationTime} min.`} valueStyle={{ fontSize: '18px'}} /> }
                </Col>
                <Col xs={12} sm={12} md={4}>
                    { restaurant && <Statistic title={"Lugares disponibles"} value={`${restaurant.reservationCapacity}`} valueStyle={{ fontSize: '18px'}} /> }
                </Col>
                <Col xs={12} sm={12} md={4}>
                    { restaurant && <Statistic title={"Aceptación de reservas"} value={restaurant.automaticReservations ? "Automatico" : "Manual"} valueStyle={{ fontSize: '18px'}} /> }
                </Col>
            </Row>
            <Row start="md" center="xs">
                <Col xs={0} md={3}></Col>
                <Col xs={12} md={9} className="btnNewReserve">
                    <Button type="dashed" icon={<FileAddOutlined />} onClick={() => onNewReserve()}>Nueva reserva</Button>
                </Col>
            </Row>
            <Row className="reservationsCont">
                <Col xs={12} md={3}>
                    {
                        nextReservations ?
                            renderSelectDateWithReservationsCalendar(nextReservations)
                            :
                            <SelectDateWithCalendar dateSelected={dateSelected} onSelected={(date) => onSelected(date)} disabledBeforeTodayDate={true} />
                    }
                </Col>
                <Col xs={12} md={9}>
                    {
                        restaurant ?
                            nextReservations ?
                                renderData(dateSelected)
                                :
                                getNextReservations()
                            :
                            <LoadingPage className="LoadingPageCont"/>
                    }
                </Col>
            </Row>
            <Modal
            name="NewReserve"
            visible={modalNewReserveVisibility}
            title="Nueva reserva"
            onCancel={handleCancelNewReserveModal}
            footer={null}
            >
                <Grid className="newReserveCont">
                    <Row>
                        <Col xs={12}>
                            <span className="titleSectionNewReserve">
                                <h2><UserOutlined style={{ color: "#94509b" }}/> Personas</h2>
                            </span>
                        </Col>
                    </Row>
                    <Row center="xs">
                        <Col xs={12}>
                            <InputNumber
                            min={1}
                            max={5}
                            step={"1"}
                            onChange={handlePeopleCountNewReserve}
                            value={peopleCountNewReserve !== null ? peopleCountNewReserve : 1} />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12}>
                            <span className="titleSectionNewReserve">
                                <h2><CalendarOutlined style={{ color: "#94509b" }}/> Fecha</h2>
                            </span>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12}>
                            <Calendar 
                            className="CalendarCont"
                            format={'DD/MM/YYYY'} 
                            defaultValue={moment(dateNewReserve, 'DD/MM/YYYY')}
                            onSelect={(date) => handleDateNewReserve(date)}
                            fullscreen={false}
                            disabledDate={(current) => {
                                let customDate = moment(new Date()).utcOffset('-0300').format("YYYY-MM-DD");
                                return current && current < moment(customDate, "YYYY-MM-DD");
                            }}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12}>
                            <span className="titleSectionNewReserve">
                                <h2><FieldTimeOutlined style={{ color: "#94509b" }}/> Hora</h2>
                            </span>
                        </Col>
                    </Row>
                    <Row center="xs">
                        <Col xs={12}>
                            <Select className="selectHourOnDateNewReserve" onChange={handleHourSelectedOnDateNewReserve} value={hourSelectedOnDateNewReserve}>
                                {
                                    hoursAvailableOnDateNewReserve !== null &&
                                        hoursAvailableOnDateNewReserve.map(hour => <Option key={hour}>{hour}</Option>)
                                }
                            </Select>
                        </Col>
                    </Row>
                    <Row className="rowInfoNewReserveCont" center="xs">
                        <Col xs={4} className="infoNewReserveCont">
                            <h3>Mesa para {peopleCountNewReserve}</h3>
                        </Col>
                        <Col xs={4} className="infoNewReserveCont">
                            <h3>{moment(dateNewReserve, "DD/MM/YYYY").format("ll")}</h3>
                        </Col>
                        <Col xs={4} className="infoNewReserveCont">
                        <h3>{hourSelectedOnDateNewReserve !== null ? `${hourSelectedOnDateNewReserve} h` : ""}</h3>
                        </Col>
                    </Row>
                    {
                        hourSelectedOnDateNewReserve &&
                        <Form form={form} initialValues={{
                            field_city: restaurant.address && restaurant.address.city ? restaurant.address.city : undefined,
                            field_province: restaurant.address && restaurant.address.province ? restaurant.address.province : undefined,
                            field_country: restaurant.address && restaurant.address.country ? restaurant.address.country : undefined
                        }}>
                            <Row>
                                <Col xs={12} sm={6} className="formItemXSBottom">
                                    <Form.Item name="field_first_name" rules={[ { required: true, message: 'Por favor, ingrese su/s nombre/s' } ]}>
                                        <Input placeholder="Nombre/s" />
                                    </Form.Item>
                                </Col>
                                <Col xs={12} sm={6}>
                                    <Form.Item name="field_last_name" rules={[ { required: true, message: 'Por favor, ingrese su/s apellido/s' } ]}>
                                        <Input placeholder="Apellido/s" />
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12} sm={6} className="formItemXSBottom">
                                    <Form.Item name="field_dni" rules={[ { required: true, message: 'Por favor, ingrese su DNI' } ]}>
                                        <Input type="number" placeholder="dni" />
                                    </Form.Item>
                                </Col>
                                <Col xs={12} sm={6}>
                                    <Form.Item name="field_email" rules={[ { type: 'email', message: 'El correo no es válido', }, { required: true, message: 'Por favor, ingrese su correo electrónico' } ]}>
                                        <Input placeholder="Correo electrónico"/>
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12} sm={6} className="formItemXSBottom">
                                    <Form.Item name="field_phone" rules={[ { required: true, message: 'Por favor, ingrese su teléfono' } ]}>
                                        <Input type="number" placeholder="Teléfono" />
                                    </Form.Item>
                                </Col>
                                <Col xs={12} sm={6}>
                                    <Form.Item name="field_street" rules={[ { required: true, message: 'Por favor, ingrese su dirección' } ]}>
                                        <Input placeholder="Dirección" />
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12} sm={6} className="formItemXSBottom">
                                    <Form.Item name="field_city" rules={[ { required: true, message: 'Por favor, ingrese su ciudad' } ]}>
                                        <Input placeholder="Ciudad" />
                                    </Form.Item>
                                </Col>
                                <Col xs={12} sm={6}>
                                    <Form.Item name="field_province" rules={[ { required: true, message: 'Por favor, ingrese su provincia' } ]}>
                                        <Input placeholder="Provincia" />
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12} sm={6}>
                                    <Form.Item name="field_country" rules={[ { required: true, message: 'Por favor, ingrese su país' } ]}>
                                        <Input placeholder="País" />
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Form>
                    }
                    <Row>
                        <Col xs={12}>
                            {
                                hoursAvailableOnDateNewReserve ?
                                    <Button className="buttonTryReserve" onClick={handleTryReserve} disabled={hourSelectedOnDateNewReserve === null} loading={reserving}>RESERVAR</Button>
                                    :
                                    <Button className="buttonGetAvailableHoursPerDate" onClick={handleGetAvailableHoursPerDate} loading={gettingAvailableHoursPerDate}>CONSULTAR DISPONIBILIDAD</Button>
                            }
                        </Col>
                    </Row>
                </Grid>
            </Modal>
        </Grid>
    );
}

TodayReservations.propTypes = {
    setNextReservationsByRestaurantId: PropTypes.func.isRequired,
    setNewStateToReserve: PropTypes.func.isRequired,
    restaurant: PropTypes.object,
    nextReservations: PropTypes.object,
};

const mapDispatchToPropsActions = dispatch => ({
    setNextReservationsByRestaurantId: value => dispatch(setNextReservationsByRestaurantId(value)),
    setNewStateToReserve: (state, newState, id) => dispatch(setNewStateToReserve(state, newState, id)),
});

const mapStateToProps = state => ({ 
    restaurant:  getRestaurant(state),
    nextReservations: getNextReservations(state),
});

export default withRouter(connect(mapStateToProps, mapDispatchToPropsActions)(TodayReservations));